import { useEffect } from "react";
import moment from "moment-timezone";
import { getToken } from "../firebaseClient";
import numbro from "numbro"
import * as Sentry from "@sentry/nextjs";
import isAbsoluteUrl from "is-absolute-url";

const localUrl = "http://localhost:5002/discovr-3175b/us-central1/";
const prodUrl = "https://us-central1-discovr-3175b.cloudfunctions.net/";
const forceProd = true;

export let baseUrl =
  (!process.env.NODE_ENV || process.env.NODE_ENV === "development") && !forceProd
    ? localUrl
    : prodUrl;

export const showThTokens = (session) => {
  return session?.user?.data?.thTokensMoneyDue > 0 && session?.user?.data?.dateSignUp?._seconds && session?.user?.data?.dateSignUp?._seconds * 1000 < new Date("2023-01-16").getTime();
};

export const getURL = () => {
  const url =
    process?.env?.URL && process.env.URL !== ""
      ? process.env.URL
      : process?.env?.VERCEL_URL && process.env.VERCEL_URL !== ""
        ? process.env.VERCEL_URL
        : "http://localhost:3000";
  return url.includes("http") ? url : `https://${url}`;
};

export const isLocal = () => {
  return (!process.env.NODE_ENV || process.env.NODE_ENV === "development");
};

export const postData = async ({ url, token, data = {} as any, session = undefined as any }) => {
  if (session) {
    data.tokenUserId = session?.user?.uid,
      data.token = await getToken(session, "postData-" + url);
  }

  const res = await fetch(baseUrl + url, {
    method: "POST",
    headers: new Headers({ "Content-Type": "application/json", token }),
    credentials: "same-origin",
    body: JSON.stringify(data),
  });

  return res.json();
};

export const getData = async ({ url, token }) => {
  const res = await fetch(baseUrl + url, {
    method: "GET",
    headers: new Headers({ "Content-Type": "application/json", token }),
    credentials: "same-origin",
  });

  return res.json();
};

export const toDateTime = (secs) => {
  const t = new Date("1970-01-01T00:30:00Z"); // Unix epoch start.
  t.setSeconds(secs);
  return t;
};

export const useOnClickOutside = (ref, handler) => {
  useEffect(
    () => {
      const listener = (event) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]
  );
}

export const shuffleArray = (a) => {
  let j, x, i;
  for (i = a?.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
  return a;
}

export const convertToAccountTimezone = (date, timezone) => {

  if (!timezone)
    return date;

  const here = moment().tz(moment.tz.guess());
  //@ts-ignore
  let diff = moment.tz.zone(timezone).utcOffset(here);
  //@ts-ignore
  let diff2 = moment.tz.zone(moment.tz.guess()).utcOffset(here);
  let timezoneDiff = diff - diff2;

  let dateTimezoned = new Date(date);
  dateTimezoned.setTime(dateTimezoned.getTime() - (1000 * 60 * timezoneDiff));

  return { date: dateTimezoned, timezoneDiff };
}

export const convertToAccountTimezoneReversed = (date, timezone) => {

  if (!timezone)
    return date;

  const here = moment().tz(moment.tz.guess());
  //@ts-ignore
  let diff = moment.tz.zone(timezone).utcOffset(here);
  //@ts-ignore
  let diff2 = moment.tz.zone(moment.tz.guess()).utcOffset(here);
  let timezoneDiff = diff - diff2;

  let dateTimezoned = new Date(date);
  dateTimezoned.setTime(dateTimezoned.getTime() + (1000 * 60 * timezoneDiff));

  return { date: dateTimezoned, timezoneDiff };
}

export const extractImages = (text) => {
  let images: any = [];
  let matchs = text.match(/(?:\[img:)(.*?)(?=\])/g);
  if (matchs && matchs?.length > 0) {
    matchs.forEach(match => {
      // console.log("match: " + match);
      match = match.replace("[img:", "");
      images.push(match);
    });
  }

  return images;
}

export const setInLocalStorage = (keyName, value) => {
  try {
    localStorage.setItem(keyName, value);
  } catch (error) {
    console.error('Error in local storage', error);
    Sentry.captureException(error);

    try {
      localStorage.clear();
      localStorage.setItem(keyName, value);
    }
    catch (error) {
      console.error('Error in local storage sub catch', error);
      Sentry.captureException(error);
    }
  }
};

export const roundUp = (value, mantissa = 1) => {
  if (value < 1000) {
    return value;
  }

  try {
    return numbro(value)?.format({
      average: true,
      mantissa: mantissa,
    });
  }
  catch (e) {
    console.log("Error in roundUp: " + e.message, e);
    Sentry.captureException(e);
    return value;
  }
};

export const getRandom = (arr, n) => {
  let result = new Array(n),
    len = arr?.length,
    taken = new Array(len);
  if (n > len)
    throw new RangeError("getRandom: more elements taken than available");
  while (n--) {
    const x = Math.floor(Math.random() * len);
    result[n] = arr[x in taken ? taken[x] : x];
    taken[x] = --len in taken ? taken[len] : len;
  }
  return result;
}

export function isNumeric(str) {
  if (typeof str != "string") return false
  //@ts-ignore
  return !isNaN(str) && !isNaN(parseFloat(str))
}

export const cleanTweetForCountChar = (text) => {

  let matchs = text.match(/(?:\[img:)(.*?)(?=\])/g);
  if (matchs) {
    matchs.forEach(match => {
      match = match + "]";
      text = text.replace(match, "");
    });
  }

  return text;
}

export const formatUrl = (url: string) => {
  try {
    if (!isAbsoluteUrl(url)) {
      return url;
    }
    const urlObject = new URL(url)

    let formattedUrl = urlObject.href.replace(`${urlObject.protocol}//`, "")

    // removed this because it was sometimes confusing for users
    // if (formattedUrl?.length > 35) {
    //   formattedUrl = formattedUrl.substring(0, 35) + "..."
    // }
    return formattedUrl
  } catch (err) {
    console.log("Error in formatUrl with url: ", url);
    console.log("Error in formatUrl with error: ", err);
    Sentry.captureException(new Error("Error in formatUrl with url: " + url));
    return url;
  }
}

export const hslToHsla = (hsl: string, alpha: number) => {
  const hsla = hsl?.replace("hsl", "hsla");
  return hsla?.replace(")", `, ${alpha})`);
}

export const hexToHexa = (hex: string, alpha: number) => {
  // @ts-ignore
  return `${hex}${Math.floor(alpha * 255).toString(16).padStart(2, 0)}`;
}

export const normalizeFancyText = (text: string): string => {
  const replacements: Array<{ from: number; to: number; base: number }> = [
    // Mathematical Bold A–Z, a–z
    { from: 0x1D400, to: 0x1D419, base: 0x41 },
    { from: 0x1D41A, to: 0x1D433, base: 0x61 },

    // Italic
    { from: 0x1D434, to: 0x1D44D, base: 0x41 },
    { from: 0x1D44E, to: 0x1D467, base: 0x61 },

    // Bold Italic
    { from: 0x1D468, to: 0x1D481, base: 0x41 },
    { from: 0x1D482, to: 0x1D49B, base: 0x61 },

    // Script (some missing in Unicode, but included here)
    { from: 0x1D49C, to: 0x1D4B5, base: 0x41 },
    { from: 0x1D4B6, to: 0x1D4CF, base: 0x61 },

    // Bold Script
    { from: 0x1D4D0, to: 0x1D4E9, base: 0x41 },
    { from: 0x1D4EA, to: 0x1D503, base: 0x61 },

    // Fraktur
    { from: 0x1D504, to: 0x1D51D, base: 0x41 },
    { from: 0x1D51E, to: 0x1D537, base: 0x61 },

    // Double-Struck
    { from: 0x1D538, to: 0x1D551, base: 0x41 },
    { from: 0x1D552, to: 0x1D56B, base: 0x61 },

    // Sans-Serif
    { from: 0x1D5A0, to: 0x1D5B9, base: 0x41 },
    { from: 0x1D5BA, to: 0x1D5D3, base: 0x61 },

    // Sans-Serif Bold
    { from: 0x1D5D4, to: 0x1D5ED, base: 0x41 },
    { from: 0x1D5EE, to: 0x1D607, base: 0x61 },

    // Sans-Serif Italic
    { from: 0x1D608, to: 0x1D621, base: 0x41 },
    { from: 0x1D622, to: 0x1D63B, base: 0x61 },

    // Sans-Serif Bold Italic
    { from: 0x1D63C, to: 0x1D655, base: 0x41 },
    { from: 0x1D656, to: 0x1D66F, base: 0x61 },

    // Monospace
    { from: 0x1D670, to: 0x1D689, base: 0x41 },
    { from: 0x1D68A, to: 0x1D6A3, base: 0x61 }
  ];

  return [...text].map(char => {
    const code = char.codePointAt(0);
    if (!code) return char;

    for (const range of replacements) {
      if (code >= range.from && code <= range.to) {
        return String.fromCharCode(code - range.from + range.base);
      }
    }

    return char;
  }).join('');
};

export const removeDiacritics = (text: string) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
